import { useCallback } from 'react';
import { usePFSessionContext } from '@/providers/PriceFreezeSessionProvider';

export const SB_ID = 'shoppingBasketId';
export const PF_ID = 'priceFreezeId';
export const BUYER_INFO = 'buyer';
export const IS_ACTIVE_PRIME_USER = 'isActivePrimeUser';
export const PF_ET = 'expirationTime';

const defaultSession = {};
const defaultSetSession = () => {};
const defaultSessionContext = [defaultSession, defaultSetSession];

export function usePriceFreezeSession() {
  const sessionContext = usePFSessionContext();
  const [session, setSession] =
    (sessionContext && sessionContext()) || defaultSessionContext;

  const set = useCallback(
    (key, value) => {
      setSession((prevState) => {
        return {
          ...prevState,
          [key]: value,
        };
      });
    },
    [setSession]
  );

  const get = useCallback(
    (key, defValue) => {
      return session && session[key] !== undefined ? session[key] : defValue;
    },
    [session]
  );

  return [get, set];
}
